import Routing from './Routing';

export default Routing;
